import React, { useState, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import FinancingCard from "./FinancingCard";
import "./FinancingCarousel.scss";

const FinancingCarousel = ({ financiaciones }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const itemsPerSlide = isMobile ? 1 : 3;
  const groupedFinanciaciones = chunkArray(financiaciones, itemsPerSlide);
  const hasMultipleSlides = groupedFinanciaciones.length > 1;
  const isSingleOption = financiaciones.length === 1;

  if (isSingleOption) {
    return (
      <div className="financing-carousel financing-carousel--single">
        <FinancingCard {...financiaciones[0]} />
      </div>
    );
  }

  return (
    <div
      className={`financing-carousel ${hasMultipleSlides ? "financing-carousel--multi" : "financing-carousel--one-slide"}`}
    >
      <Carousel
        indicators={hasMultipleSlides}
        controls={hasMultipleSlides}
        interval={null}
        className="financing-carousel__inner"
      >
        {groupedFinanciaciones.map((group, groupIdx) => (
          <Carousel.Item key={groupIdx} className="financing-carousel__item">
            <div className="row w-100 g-3 justify-content-center">
              {group.map((f, idx) => (
                <div
                  key={f.id || idx}
                  className={isMobile ? "col-12" : group.length === 1 ? "col-12 col-lg-8" : "col-lg-4 col-md-4"}
                >
                  <FinancingCard {...f} />
                </div>
              ))}
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
};

export default FinancingCarousel;
